var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonNewGame"},[(_vm.userHasPermission(_vm.permissions.apps.add))?_c('el-button',{staticClass:"submit-game",attrs:{"type":"primary","data-test-id":"myGamesEmptyStateCreateAppButton"},on:{"click":function($event){return _vm.gotoSubmitFlow()}}},[_vm._v("Create an App test")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }